import { BillType } from '../../../../graphql/generated/graphql'
import autoLoan from '../../../../assets/img/bill-type-auto-loan.svg'
import mortgage from '../../../../assets/img/bill-type-mortgage.svg'
import creditCard from '../../../../assets/img/bill-type-credit-card.svg'
import loan from '../../../../assets/img/bill-type-loan.svg'
import studentLoan from '../../../../assets/img/bill-type-student-loan.svg'
import utility from '../../../../assets/img/bill-type-utility.svg'
import payOthers from '../../../../assets/icons/pay-someone.png'
import styled from 'styled-components'
import { themedImage } from '../../../../theme/utils'

export const typeDescription: Record<BillType, string> = {
    [BillType.AutoLoan]: 'Auto loan',
    [BillType.CreditCard]: 'Credit card',
    [BillType.Loan]: 'Loan',
    [BillType.Mortgage]: 'Mortgage',
    [BillType.StudentLoan]: 'Student loan',
    [BillType.Unknown]: 'Bill',
    [BillType.Utility]: 'Utility',
    [BillType.MobilePhone]: 'Phone',
}

const typeImage: Record<BillType | 'pay-others', { name: string; default: string }> = {
    [BillType.AutoLoan]: { name: 'billTypeAutoLoan', default: autoLoan },
    [BillType.CreditCard]: { name: 'billTypeCreditCard', default: creditCard },
    [BillType.Loan]: { name: 'billTypeLoan', default: loan },
    [BillType.Mortgage]: { name: 'billTypeMortgage', default: mortgage },
    [BillType.StudentLoan]: { name: 'billTypeStudentLoan', default: studentLoan },
    [BillType.Unknown]: { name: 'billTypeLoan', default: loan },
    [BillType.Utility]: { name: 'billTypeUtility', default: utility },
    [BillType.MobilePhone]: { name: 'billTypeAutoLoan', default: loan },
    ['pay-others']: { name: 'paySomeone', default: payOthers },
}

const Image = styled.img`
    width: 31px;
    height: auto;
`

export const BillIcon = ({ type }: { type: BillType | 'pay-others' }) => {
    const src = themedImage(typeImage[type].name, typeImage[type].default) ?? loan
    return <Image src={src} />
}
